import React from 'react';
import { Route } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import KpisContainer from './containers/Kpis.container';

export const KpisModule: React.FC = () => {
  return <Route path={APP_ROUTES.KPIS_MODULE.FULL_PATH} component={KpisContainer} />;
};
